// @flow
import { connect } from 'react-redux';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router';

// Actions
import { goTo } from 'store/reducers/navigation/actions';
import { checkIn } from 'store/reducers/selfCheckIn/actions';

// Selectors
// @TODO: uncomment when backend sends correct serviceList
// import { getAdditionalSelfCheckInServices } from 'store/reducers/dealerData/selectors';
import { getSelfCheckInFlow } from 'store/reducers/selfCheckIn/selectors';
import { showSCIProgressBar } from 'store/reducers/optimizelyABTest/selectors';

// Component
import EditServicesPage from './EditServicesPage';

const mapStateToProps = state => ({
  // @TODO: uncomment when backend sends correct serviceList
  // services: getAdditionalSelfCheckInServices(state)
  selfCheckInFlow: getSelfCheckInFlow(state),
  showSCIProgressBar: showSCIProgressBar(state)
});

export default compose(
  withRouter,
  injectIntl,
  connect(
    mapStateToProps,
    {
      goTo,
      checkIn
    }
  )
)(EditServicesPage);



// WEBPACK FOOTER //
// ./src/components/pages/SelfCheckIn/EditServicesPage/EditServicesPageContainer.js